const errorSource = {
  CLIENT: 'CLIENT',
  SERVER: 'SERVER',
};

export default errorSource;
